import React, { useEffect, useState } from "react";
import Script from "next/script";
import { Box } from "@pagepro-monorepo/ui/lib/components/styles/Grid";

import { CalendlyWidgetProps } from "./types";

const CalendlyhWidget: React.FC<CalendlyWidgetProps> = ({ url }) => {
  const [height, setHeight] = useState(700);

  useEffect(() => {
    const onHeightChange = (e: MessageEvent) => {
      if (e?.data?.payload?.height) {
        setHeight(e?.data?.payload?.height);
      }
    };

    window.addEventListener("message", onHeightChange);

    return () =>
      window.removeEventListener("message", onHeightChange);
  }, []);

  return (
    <>
      <Box
        className="calendly-inline-widget"
        data-url={url}
        data-resize="true"
        minWidth={320}
        height={height}
      />
      <Script
        type="text/javascript"
        src="https://assets.calendly.com/assets/external/widget.js"
        async
      />
    </>
  );
};

export default CalendlyhWidget;
